var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-footer__other-sites m-dynamic--x",
      class: {
        "rb-footer__other-sites--show": _vm.isVisible(),
        "rb-footer__other-sites--hide": !_vm.isVisible(),
      },
      attrs: { id: "rb-footer__other-sites" },
    },
    [
      _c(
        "button",
        {
          staticClass: "rb-footer__other-sites--close",
          on: {
            click: function ($event) {
              return _vm.toggle()
            },
          },
        },
        [_c("rb-lazy-icon", { attrs: { icon: "close-light", text: "close" } })],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }